<template>
  <div class="h-full">
    <Main>
      <div v-if="$vuetify.breakpoint.xsOnly && !isDraftCustomerReview" class="w-full d-flex justify-end">
        <CUIcon view-box="0 0 24 24" @click="close">
          close
        </CUIcon>
      </div>
      <div v-if="showHeader" class="d-flex align-center justify-space-between">
        <div
          :class="{
            'd-flex align-center': $vuetify.breakpoint.smAndUp,
          }"
        >
          <h1 class="margin-y-0">
            Trip Modification Request
          </h1>
          <p
            class="font-20"
            :class="{
              'margin-l-4 margin-y-0': $vuetify.breakpoint.smAndUp,
              'margin-t-2': $vuetify.breakpoint.xsOnly,
            }"
          >
            {{ subHeader }}
          </p>
        </div>
        <CUIcon
          v-if="$vuetify.breakpoint.smAndUp && !isDraftCustomerReview"
          class="cursor-pointer"
          view-box="0 0 24 24"
          @click="value = true"
        >
          close
        </CUIcon>
      </div>
      <WizardProgressTracker
        v-if="showHeader"
        :wizard-store="tripModification"
        class="margin-t-8"
      />
      <TripModificationError v-if="isDraftInProgress" />
      <component v-else :is="component" :reservation="reservation"/>
    </Main>
    <TripModificationFooter />
    <TripModificationCloseDialog v-model="value" />
  </div>
</template>

<script lang="ts" setup>
import { ref, computed, onMounted, onBeforeUnmount, provide } from 'vue'
import Main from '@/layouts/Main.vue'
import TripModificationFooter from '@/components/TripModificationFooter.vue'
import WizardProgressTracker from '@/components/WizardProgressTracker.vue'
import TripModificationCloseDialog from '@/components/TripModificationCloseDialog.vue'
import TripModificationError from '@/components/TripModificationError.vue'
import tripModification from '@/store/modules/tripModification'
import { TripModificationStep } from '@/models/TripModification'
import { ReservationDetail } from '@/models/dto'
import { TripModificationStepKey } from '@/utils/enum'

provide('removePadding', true)

const props = defineProps<{
  reservation: ReservationDetail
  trip?: any
}>()

const value = ref(false)

const subHeader = computed(() => {
  const { managedId, routeName } = props.reservation
  const formattedId = `ID ${managedId}`
  return routeName ? `${routeName} – ${formattedId}` : formattedId
})

const currentStep = computed<TripModificationStep>(() => tripModification.step)

const component = computed(() => currentStep.value?.component)

const showHeader = computed(() => {
  if (isDraftInProgress.value) {
    return false
  }
  return ![TripModificationStepKey.Confirmation, TripModificationStepKey.Application, TripModificationStepKey.SubmissionError].includes(currentStep.value.key)
})

const isDraftInProgress = computed(() => tripModification.isDraftInProgress)

const isDraftCustomerReview = computed(() => tripModification.isDraftCustomerReview)

const close = () => {
  tripModification.setIsOpen(false)
}

onMounted(() => {
  tripModification.setManagedId(props.reservation.managedId)
  tripModification.setRouteName(props.reservation.routeName)
  if (tripModification.isDraftCustomerReview) {
    tripModification.startDraftCustomerReview()
  } else {
    tripModification.start()
  }
})

onBeforeUnmount(() => {
  close()
})
</script>
